import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { IBoton } from 'modelos/src';
import {
  AgregarBotonServicioDialogComponent,
  DatosAgregarBotonServicio,
} from '../agregar-boton-servicio-dialog/agregar-boton-servicio-dialog.component';

/**
 * Sección "Servicios o Trámites" del tab App Nativa: botones que se muestran en esa pantalla de
 * la app nativa (menú "Más"), sobre el fondo del cliente, cuando `configuracion.mostrarServiciosTramites`
 * está activo.
 *
 * A diferencia de `categorias-seccion`, acá los botones ya existen siempre (se eligen del catálogo
 * global, nunca se crean desde acá) — por eso `ids` es directamente `string[]`, sin `FormArray` ni
 * objetos editables. Se recibe POR REFERENCIA y se muta in-place (push/splice/reorder), igual que
 * `categorias-seccion` hace con `categorias`.
 */
@Component({
  selector: 'app-servicios-tramites-seccion',
  templateUrl: './servicios-tramites-seccion.component.html',
  styleUrls: ['./servicios-tramites-seccion.component.scss'],
  standalone: false,
})
export class ServiciosTramitesSeccionComponent {
  private matDialog = inject(MatDialog);

  /** Ids de botón en orden. Se muta in-place. */
  @Input() ids: string[] = [];
  /** Catálogo global de botones (ya cargado por el padre: `cliente-form.component.ts`). */
  @Input() botonesCatalogo: IBoton[] = [];

  private get porId(): Map<string, IBoton> {
    return new Map(this.botonesCatalogo.map((b) => [b._id!, b]));
  }

  public etiqueta(id: string): string {
    const b = this.porId.get(id);
    if (!b) return id;
    return b.variante ? `${b.nombre} (${b.variante})` : (b.nombre ?? id);
  }

  public drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.ids, event.previousIndex, event.currentIndex);
  }

  public async agregar(): Promise<void> {
    const data: DatosAgregarBotonServicio = {
      botones: this.botonesCatalogo,
      yaUsados: this.ids,
    };
    const ref = this.matDialog.open<
      AgregarBotonServicioDialogComponent,
      DatosAgregarBotonServicio,
      string[]
    >(AgregarBotonServicioDialogComponent, {
      data,
      width: '600px',
      maxWidth: '95vw',
    });
    const idsNuevos = await firstValueFrom(ref.afterClosed());
    if (!idsNuevos?.length) return;
    const yaUsados = new Set(this.ids);
    for (const id of idsNuevos) {
      if (!yaUsados.has(id)) this.ids.push(id);
    }
  }

  public quitar(i: number): void {
    this.ids.splice(i, 1);
  }
}
